import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { arrayMapper } from '@common/operators';

import { ReportsMiscApiService } from '../api';
import { DomainReport, Report, ScheduleDescription, ShortRecipient } from './models';
import { UpdateReportApi } from '@apps/rept/api/view-models';
import { DatesService } from '@common/services';
@Injectable({
    providedIn: 'root'
})
export class ReportsMiscDomainService
{
    constructor (
        private reportsMiscApiService: ReportsMiscApiService,
        private datesService: DatesService
    )
    {
    }

    getReports (): Observable<Report[]>
    {
        return this.reportsMiscApiService.getReports()
            .pipe(
                arrayMapper(DomainReport.mapperFromApi)
            );
    }
    
    getReport (reportId: string): Observable<Report>
    {
        return this.reportsMiscApiService.getReport(reportId)
            .pipe(
                map(DomainReport.mapperFromApi)
            );
    }

    createReport (report: Report): Observable<Report>
    {
        return this.reportsMiscApiService.createReport(report)
            .pipe(
                map(DomainReport.mapperFromApi)
            );
    }

    nextSchedule (sd: ScheduleDescription): Observable<string>
    {
        return this.reportsMiscApiService.nextSchedule(sd)
            .pipe(
                map((ns: string): string =>
                    this.datesService.DateTimeToDateHour(DatesService.UtcStringToDateTimeHourStatic(ns))
                )
            );
    }

    updateReport (report: Report): Observable<Report>
    {
        const updateReportApi: UpdateReportApi = UpdateReportApi.mapperToApi(report);
        return this.reportsMiscApiService.updateReport(updateReportApi)
            .pipe(
                map(DomainReport.mapperFromApi)
            );
    }

    deleteReport (report: Report): Observable<Report>
    {
        return this.reportsMiscApiService.deleteReport(report.reportId)
            .pipe(
                map(DomainReport.mapperFromApi)
            );
    }

    toggleActivationReport (report: Report, toggle: boolean): Observable<Report>
    {
        return this.reportsMiscApiService.toggleActivationReport(report.reportId, toggle)
            .pipe(
                map(DomainReport.mapperFromApi)
            );
    }

    addDefaultContractualReports (entityId: string): Observable<Report[]>
    {
        return this.reportsMiscApiService.addDefaultContractualReports(entityId)
            .pipe(
                arrayMapper(DomainReport.mapperFromApi)
            );
    }

    replayReport (reportId: string): Observable<boolean>
    {
        return this.reportsMiscApiService.replayReport(reportId);
    }
}
